import * as React from "react";
import {cx} from "emotion";

import "./sc-mailing-seals.scss";

import {cs}                from "@Common/react/chain-services";
import {scnv}              from "@Common/react/state-change-nested-value";
import {UseState}          from "@Common/react/use-state";
import {Badge}             from "@Common/ui-components/heavy/common/design2/badge/badge";
import {setCurrentToSaved} from "@Common/ui-components/heavy/item-options/modules/set-current-to-saved";
import {formatMoney1}      from "@Common/ui-components/language/format-money";
import {SliderCheckbox}    from "@Common/ui-components/slider-checkbox/slider-checkbox";
import {snv}               from "@Common/utils/arr-path";
import {cascadeChange}     from "@Common/utils/cascade";
import {chain}             from "@Common/utils/fs";
import {omit}              from "@Common/utils/objects";

import {MoneySpan} from "@Xpresso/routes/common/form/money-span/money-span";

// -"default"
// -true
// -false
export const ScMailingSeals = ({liveData, config, disabled, program, next}) => cs(
    ["userChoice", (_, next) => UseState({
        getInitValue: () => chain(
            liveData?.["mailingSeals"],
            (_) => ({
                current: _,
                saved  : _,
            }),
        ),
        next,
    })],


    ["calValue", ({userChoice}, next) => next(userChoice.value.current ?? "default")],
    ["displayValue", ({calValue}, next) => next(
        calValue === "default" ? (
            false
        ) : (
            calValue
        )
    )],

    ["disabled1", ({}, next) => next(
        disabled || !program?.programPreferences?.allowMailingSeals
    )],

    ({userChoice, calValue, displayValue, disabled1}) => next({

        enrollmentEditor: {
            prepareSave: (data) => ({
                newValue: config && !disabled1 ? (
                    cascadeChange(data, "seriesPreferences[*]", (s1) => snv(s1, ["productOptions", "mailingSeals"], calValue))
                ) : (
                    cascadeChange(data, "seriesPreferences[*].productOptions", (p1) => omit(p1, ["mailingSeals"]))
                ),
                onSaved: () => setCurrentToSaved(userChoice),
            }),
            changed: calValue !== userChoice.value.saved,
            valid: true,
        },

        summaryLine: (
            config &&
            userChoice.value.current && userChoice.value.current !== "default"
        ) && {
            name: "Mailing Seals",
            value: (
                +config.flatPrice ? (
                    formatMoney1(+config.flatPrice)
                ) : (
                    Badge({
                        color: "green",
                        text: "Free",
                        xdQaName: "Mailing Seals" + " Free"
                    })
                )
            ),
        },

        ...(config && !disabled1) && {
            render: () => (
                <div {...{
                    className: cx("sc-mailing-seals-4li"),
                }}>

                    {SliderCheckbox({
                        value: displayValue,
                        onChange: () => {
                            scnv(userChoice, ["current"], () => !displayValue);
                        },
                    })}

                    <div className="info">
                        <div className="line1">
                            <div className="title">
                                {config.name}
                            </div>


                            {MoneySpan({
                                value: +config.flatPrice,
                                xdQaName: "Mailing Seals" + " Price",
                            })}

                        </div>
                        <div className="description">
                            {config.description}
                        </div>
                    </div>

                </div>
            ),
        },
    }),
);

